/* eslint-disable max-len */
export default {
  ACTIONS: {
    FINISH: 'Concluir',
    NEXT: 'Continuar'
  },
  ERRORS: {
    GREATER_THAN: 'Não pode ser maior do que {max}.',
    INVALID_PROZIS_POINTS:
      'Ups, os ProzisPoints que querias partilhar com o estafeta já não estão disponíveis. Tenta novamente.',
    LESS_THAN: 'Não pode ser menor do que {min}.',
    MAX_CHARACTERS: 'A descrição deve ter um máximo de {max} carateres.',
    REQUIRED: 'Campo obrigatório.',
    VALIDATING_CODE: 'Não foi possível validar o código {code}.'
  },
  LABELS: {
    COMMENT: 'Comentário',
    COURIER: 'estafeta',
    ERROR: 'Erro',
    EXPERIENCE_EVALUATION: 'AVALIA A EXPERIÊNCIA DE ENTREGA',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    OTHER: 'Outro',
    PROZIS_NOW: 'PROZIS NOW'
  },
  SENTENCES: {
    AMAZED:
      '😁 Ficamos muito contentes que tenha corrido tudo bem. De que é que gostaste mais?',
    ANSWERED_SURVEY:
      'Já tínhamos recebido o teu feedback em relação à entrega da encomenda {code}. \n\rFicamos à espera da tua opinião sobre a próxima experiência. 👍',
    ENTITY: 'O que achaste do(a) {entity}?',
    POINTS: 'Tens {points} ProzisPoints.',
    SATISFIED:
      '😁 Ficamos contentes que tenha corrido bem, mas o que podemos melhorar?',
    SHARE_POINTS:
      'Gostarias de gratificar o(a) {entity}? Partilha os teus ProzisPoints com ele(a). 🙂',
    THANKS: '😀 Obrigado, {name}.',
    UNHAPPY:
      '😔 Ficamos tristes em saber que a entrega não correu como esperado. O que correu mal?'
  }
};
